import * as React from "react";
import VirtualPagination from "@tunnel-components/@sharded/@widgets/virtualized/pagination";
import * as Lodash from "lodash";
import Incidents from "@tunnel-components/@sharded/widgets/incidents-tmd/component";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    incidentData,
    totalRowElements,
    actionLoader,
    onQualified,
    totalElements,
    itemsPerPage,
    itemPerRow,
    acknowledged,
    onUpdateCurrentPageNumber,
    currentPageNumbers,
    authorization,
    onUpdateScrollTop,
    /** Intégration des actions */
    /** actionLoader ,onUpdateScrollTop , */
  } = props;

  /**
   * a callback method to define yourself depending on what you want
   * to do with your data. This method is the core of your list,
   * it is here that you define what will be rendered thanks to your data
   */
  const rowRenderer = ({ index, key, style }: any): JSX.Element => {
    /**
     * @constant
     * @description :
     * @name  itemPerRowLine
     * @types number
     */
    const itemPerRowLine: number =
      !!incidentData && incidentData.length <= 3
        ? incidentData.length
        : itemPerRow;
    /**
     * @constant
     * @description :
     * @name  items
     * @types any[]
     */
    const items: any[] = [];
    /**
     * @constant
     * @description :
     * @name  fromIndex
     * @types number
     */
    const fromIndex: number = index * itemPerRowLine;
    /**
     * @constant
     * @description :
     * @name  toIndex
     * @types number
     */
    const toIndex: number = Math.min(
      fromIndex + itemPerRowLine,
      totalRowElements
    );

    {
      /** Boucle */
    }
    for (let i = fromIndex; i < toIndex; i++) {
      {
        /** Création du tableau des items */
      }

      items.push(
        <Incidents
          key={i}
          index={i}
          item={
            incidentData[i] &&
            !Lodash.isUndefined(incidentData[i]) &&
            !Lodash.isEmpty(incidentData[i]) &&
            incidentData[i]
          }
          actionLoader={actionLoader[i] && actionLoader[i]}
          isQualifyFunction={onQualified(
            incidentData[i] && incidentData[i].id,
            0,
            i
          )}
          authorization={authorization}
          acknowledged={acknowledged && acknowledged[i]}
        />
      );
    }
    /**
     * Afffichage
     */
    return (
      <div
        key={key}
        style={{
          ...style,
          width: "100%",
        }}
      >
        {!Lodash.isUndefined(incidentData[index]) &&
          !Lodash.isEmpty(incidentData[index]) &&
          !!incidentData[index] &&
          items}
      </div>
    );
  };
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <VirtualPagination
      classnames="incident-items" // la classe
      incident={true}
      onUpdateScrollTop={onUpdateScrollTop}
      itemPerRow={
        incidentData && incidentData.length <= 3
          ? incidentData.length
          : itemPerRow
      }
      totalRowElements={totalRowElements}
      widthView="100%" //
      heightView="100%" // hauteur et largeur de la fenètre
      rowHeight={500} // Hauteur de la cellule
      arrayContent={!Lodash.isEmpty(incidentData)} // Boolean vérifie si le tableau est vide
      rowRenderer={rowRenderer} // élement JSX , column
      itemPerPage={itemsPerPage} // nombre d'élement par page
      totalItemLength={totalElements} // nombre total d'élement
      currentPageNumbers={currentPageNumbers} // la page courante
      onUpdateCurrentPageNumbers={onUpdateCurrentPageNumber} // function de mise à jour de la page courante
    />
  );
};

// initialisation des props

Component.defaultProps = {};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  onUpdateScrollTop?: any;
  loading?: any;
  incidentData?: any;
  errorserver?: any;
  totalElements?: any;
  itemsPerPage?: any;
  onUpdateCurrentPageNumber?: any;
  currentPageNumbers?: any;
  itemPerRow?: any;
  onChangeItemPerRow?: any;
  ongletActive?: any;
  onClickOnglet?: any;
  totalRowElements?: any;
  acknowledged?: any;
  //
  identifiantActifSea?: any;
  selectedValueSearch?: any;
  actionFalseAlarmPatternsError?: any;
  onSubmitSeaPatterns?: any;
  onChangePatterns?: any;
  onSearchValue?: any;
  patternfalseAlarm?: any;
  selectedOptionsIncident?: any;
  onCloseSeaPatterns?: any;
  onSubmitPatterns?: any;
  actionFalseAlarmPatterns?: any;
  actionSeaPatterns?: any;
  onQualified?: any;
  onDeleteFakeIncident?: any;
  actionLoader?: any;
  onClosePattern?: any;
  authorization?: any;
  rediRectToo?: any;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/incidents-tmd/component.tsx